export const SITE_URL = `https://${window.location.hostname}/`;
